import { render } from "./InputEditor.vue?vue&type=template&id=f355c08a&scoped=true"
import script from "./InputEditor.vue?vue&type=script&lang=js"
export * from "./InputEditor.vue?vue&type=script&lang=js"

import "./InputEditor.vue?vue&type=style&index=0&id=f355c08a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f355c08a"]])

export default __exports__